export const bank = {
  interestRatePerTick: 0.001,
};
